module.exports = {
  "roster": [
    {
      "id": "dong-zhuo",
      "name": "董卓",
      "title": "西涼太師",
      "stats": {
        "capital": 8,
        "luck": 5,
        "negotiation": 5,
        "charisma": 5,
        "tech": 5,
        "stamina": 6
      },
      "passive": {
        "id": "enforcer",
        "name": "Enforcer",
        "description": "Designate one owned property as regulated; opponents pay +20% rent there."
      },
      "color": "#f57f17"
    },
    {
      "id": "cao-cao",
      "name": "曹操",
      "title": "魏武王",
      "stats": {
        "capital": 4,
        "luck": 6,
        "negotiation": 9,
        "charisma": 5,
        "tech": 5,
        "stamina": 5
      },
      "passive": {
        "id": "speculator",
        "name": "Speculator",
        "description": "Re-draw an event card you do not like. Negative event duration -1 turn."
      },
      "color": "#00695c"
    },
    {
      "id": "zhang-fei",
      "name": "張飛",
      "title": "燕人張翼德",
      "stats": {
        "capital": 5,
        "luck": 5,
        "negotiation": 5,
        "charisma": 5,
        "tech": 6,
        "stamina": 8
      },
      "passive": {
        "id": "breaker",
        "name": "Breaker",
        "description": "Reduce rent you pay on opponents' monopoly properties by 25%."
      },
      "color": "#6a1b9a"
    },
    {
      "id": "guan-yu",
      "name": "關羽",
      "title": "美髯公",
      "stats": {
        "capital": 5,
        "luck": 5,
        "negotiation": 5,
        "charisma": 9,
        "tech": 5,
        "stamina": 5
      },
      "passive": {
        "id": "idealist",
        "name": "Idealist",
        "description": "Gain +$50 each time you pass GO (stacks with the salary)."
      },
      "color": "#ffd54f"
    },
    {
      "id": "liu-bei",
      "name": "劉備",
      "title": "昭烈帝",
      "stats": {
        "capital": 4,
        "luck": 6,
        "negotiation": 5,
        "charisma": 9,
        "tech": 5,
        "stamina": 5
      },
      "passive": {
        "id": "pioneer",
        "name": "Pioneer",
        "description": "Property upgrade cost -20%."
      },
      "color": "#b5651d"
    },
    {
      "id": "lu-bu",
      "name": "呂布",
      "title": "飛將軍",
      "stats": {
        "capital": 5,
        "luck": 5,
        "negotiation": 6,
        "charisma": 5,
        "tech": 5,
        "stamina": 8
      },
      "passive": {
        "id": "breaker",
        "name": "Breaker",
        "description": "Reduce rent you pay on opponents' monopoly properties by 25%."
      },
      "color": "#7e57c2"
    },
    {
      "id": "yuan-shao",
      "name": "袁紹",
      "title": "冀州牧",
      "stats": {
        "capital": 9,
        "luck": 4,
        "negotiation": 5,
        "charisma": 5,
        "tech": 5,
        "stamina": 6
      },
      "passive": {
        "id": "financier",
        "name": "Financier",
        "description": "Property purchase price -10%. Financial negative-event losses -20%."
      },
      "color": "#ff8f00"
    },
    {
      "id": "li-ru",
      "name": "李儒",
      "title": "謀士",
      "stats": {
        "capital": 5,
        "luck": 5,
        "negotiation": 5,
        "charisma": 5,
        "tech": 9,
        "stamina": 5
      },
      "passive": {
        "id": "arbitrageur",
        "name": "Arbitrageur",
        "description": "Gain $100 whenever any player goes bankrupt. Rebuild cost -30%."
      },
      "color": "#212121"
    }
  ],
  "lore": {
    "dong-zhuo": {
      "nameZh": "董卓",
      "titleZh": "西涼太師",
      "identity": "反派，權臣",
      "alignment": "混亂邪惡",
      "background": "董卓，字仲穎，出身於西涼，因其卓越的軍事才能和權謀手段而迅速崛起於東漢末年。他以殘忍和驕傲著稱，常以暴力和恐懼來鞏固自己的權力。董卓在朝中擁有極大的影響力，並不惜一切代價來維護自己的地位。",
      "joining": "董卓在漢靈帝駕崩後，趁機進京掌控朝政，並自封為太師，實行暴政，令百姓苦不堪言。",
      "styleIntro": "董卓的戰鬥風格充滿了殘忍和權謀，讓敵人無法預測他的下一步行動。",
      "style": [
        "利用恐懼和暴力來壓制敵人。",
        "擅長權謀，能夠在政治鬥爭中占據上風。",
        "驕傲自大，常常低估敵人，卻又能在危機時刻迅速反應。"
      ],
      "styleOutro": "董卓的戰鬥風格讓他成為一個難以對付的對手，無論是在戰場上還是政治舞台上。",
      "relationships": [
        {
          "target": "李儒",
          "description": "李儒是董卓的謀士，兩人合作無間，共同策劃了多次政治陰謀。"
        },
        {
          "target": "呂布",
          "description": "董卓收呂布為義子，並賜予重任，但兩人之間的關係充滿了猜忌和不信任。"
        }
      ],
      "themeSummary": "董卓的故事是一個關於權力、驕傲和殘忍的警示，展示了權力的腐蝕性和暴政的危害。"
    },
    "cao-cao": {
      "nameZh": "曹操",
      "titleZh": "魏武王",
      "identity": "權臣，後來的敵人",
      "alignment": "魏國",
      "background": "曹操，字孟德，出身於一個顯赫的家族，從小便展現出非凡的才智和野心。他以權謀和果斷著稱，並在亂世中迅速崛起，成為一位不可忽視的政治和軍事領袖。",
      "joining": "曹操在黃巾之亂後迅速崛起，並在董卓之亂中展現出卓越的軍事才能，最終建立了自己的勢力，成為魏國的奠基者。",
      "styleIntro": "曹操的風格以權謀和果斷著稱，他的策略往往出人意料，卻又精準無比。",
      "style": [
        "善於利用敵人的弱點，並在關鍵時刻果斷出擊。",
        "擅長結合政治和軍事手段，以達成自己的目標。",
        "常常在戰場上展現出非凡的勇氣和智慧。"
      ],
      "styleOutro": "曹操的策略和風格使他成為三國時期最具影響力的人物之一。",
      "relationships": [
        {
          "target": "董卓",
          "description": "曹操曾試圖刺殺董卓，但未能成功，這一事件使他成為董卓的敵人之一。"
        },
        {
          "target": "劉備",
          "description": "曹操與劉備之間既有合作也有對抗，兩人互相尊重但最終成為敵人。"
        }
      ],
      "themeSummary": "曹操的故事是一個關於權力、野心和策略的傳奇，他在亂世中以非凡的智慧和果斷的行動建立了自己的帝國。"
    },
    "zhang-fei": {
      "nameZh": "張飛",
      "titleZh": "燕人張翼德",
      "identity": "劉備的结义兄弟，勇猛的武将",
      "alignment": "蜀汉",
      "background": "張飛，字翼德，乃燕人，因勇猛无畏而闻名于世。他与劉備、關羽结为异姓兄弟，誓同生死，共图大业。张飞以其直率的性格和忠义的品格，成为蜀汉的重要将领。",
      "joining": "张飞在桃园三结义时，与劉備、關羽结为兄弟，誓同生死，共同辅佐劉備建立蜀汉。",
      "styleIntro": "张飞的战斗风格以勇猛和直率著称：",
      "style": [
        "勇猛无畏，常以一敌百。",
        "直率果敢，毫不掩饰自己的情感。",
        "忠于兄弟，誓死捍卫劉備的事业。"
      ],
      "styleOutro": "张飞的勇猛和忠诚使他成为蜀汉不可或缺的力量。",
      "relationships": [
        {
          "target": "劉備",
          "description": "张飞与劉備是结义兄弟，誓同生死，共同辅佐劉備建立蜀汉。"
        }
      ],
      "themeSummary": "张飞的故事是关于勇猛、忠义和兄弟情谊的传奇。他的直率和无畏使他成为战场上的无敌勇士，而他的忠诚则使他成为劉備最可靠的支持者。"
    },
    "guan-yu": {
      "nameZh": "關羽",
      "titleZh": "美髯公",
      "identity": "劉備的兄弟，武將",
      "alignment": "忠義",
      "background": "關羽，字雲長，河東解人，乃三國時期著名的武將，以忠義勇猛著稱。自幼習武，精通兵法，後來與劉備、張飛結為異姓兄弟，誓同生死。關羽以其過人的武藝和智謀，成為劉備麾下的重要將領，屢次在戰場上立下赫赫戰功。",
      "joining": "關羽在桃園三結義中與劉備、張飛結為兄弟，從此追隨劉備，為其效力。",
      "styleIntro": "關羽的戰鬥風格以勇猛和智謀著稱，常常在戰場上以一敵百，無人能擋。",
      "style": [
        "使用青龍偃月刀，威力無比。",
        "擅長騎馬作戰，速度與力量兼備。",
        "善於利用地形和戰術，出奇制勝。"
      ],
      "styleOutro": "關羽的每一次出擊都如同一場精心策劃的演出，讓敵人無法招架。",
      "relationships": [
        {
          "target": "劉備",
          "description": "關羽與劉備是結義兄弟，兩人情同手足，關羽對劉備忠心耿耿，誓死效忠。"
        }
      ],
      "themeSummary": "關羽的故事是忠義與勇猛的化身，他的每一次戰鬥都充滿了智慧與勇氣，成為後世英雄的典範。"
    },
    "lu-bu": {
      "nameZh": "呂布",
      "titleZh": "飛將軍",
      "identity": "三國時期著名的武將，以勇猛無比而聞名。",
      "alignment": "中立",
      "background": "呂布，字奉先，五原郡九原县人，三國時期著名的武將，以勇猛無比而聞名。呂布自幼習武，擅長騎射，因其武藝高強，被譽為“飛將軍”。他曾效力於丁原，後來因為董卓的重用而背叛丁原，成為董卓的義子。呂布雖然勇猛，但性格多變，常因一時之利而背叛盟友。",
      "joining": "呂布在董卓的引薦下加入了朝廷，並迅速崛起，成為一名備受矚目的將軍。",
      "styleIntro": "呂布的戰鬥風格以勇猛著稱，無人能敵。",
      "style": [
        "擅長騎射，能在戰場上迅速移動並發起猛烈攻擊。",
        "以一敵百，常常單槍匹馬衝入敵陣，令敵人聞風喪膽。"
      ],
      "styleOutro": "然而，呂布的無謀和多變性格也使他在戰場上容易被敵人利用。",
      "relationships": [
        {
          "target": "董卓",
          "description": "呂布曾是董卓的義子，兩人關係密切，但最終因利益衝突而反目。"
        },
        {
          "target": "曹操",
          "description": "呂布與曹操曾有過短暫的合作，但最終因為呂布的背叛而成為敵人。"
        }
      ],
      "themeSummary": "呂布的故事是一個關於勇猛與無謀的傳奇，展現了他在戰場上的無敵風采以及因性格缺陷而導致的悲劇命運。"
    },
    "liu-bei": {
      "nameZh": "劉備",
      "titleZh": "昭烈帝",
      "identity": "漢室宗親",
      "alignment": "正義",
      "background": "劉備，字玄德，是東漢末年的著名軍事家和政治家。他是漢室宗親，擁有高尚的品德和遠大的志向。劉備以仁慈和勇敢著稱，並以恢復漢室為己任。",
      "joining": "劉備在桃園結義後，與關羽和張飛結成兄弟，開始了他的征戰之路。他的目標是匡扶漢室，重振大漢的榮光。",
      "styleIntro": "劉備的戰鬥風格體現了他的仁慈和勇敢：",
      "style": [
        "他總是優先考慮人民的福祉，並以仁愛之心對待部下。",
        "在戰場上，他勇往直前，從不畏懼強敵。"
      ],
      "styleOutro": "這些特質使他成為一位受人尊敬的領袖。",
      "relationships": [
        {
          "target": "關羽",
          "description": "關羽是劉備的結義兄弟，兩人情同手足，並肩作戰。"
        },
        {
          "target": "張飛",
          "description": "張飛是劉備的結義兄弟，三人共同發誓要匡扶漢室。"
        },
        {
          "target": "曹操",
          "description": "曹操曾邀請劉備共謀大事，但劉備心懷漢室，最終選擇與曹操對立。"
        }
      ],
      "themeSummary": "劉備的故事是一個關於忠誠、仁愛和不屈不撓的奮鬥精神的傳奇。他的目標是恢復漢室的榮光，並為此不懈努力。"
    },
    "yuan-shao": {
      "nameZh": "袁紹",
      "titleZh": "冀州牧",
      "identity": "權臣，後來的敵人",
      "alignment": "中立",
      "background": "袁紹出身於四世三公的名門望族，擁有深厚的政治背景和影響力。他在漢末動亂中迅速崛起，成為一方諸侯，並以冀州為根據地，逐步擴大勢力。",
      "joining": "袁紹在漢末群雄逐鹿的時代中，憑藉其家族的影響力和個人的政治手腕，迅速集結了一批忠誠的追隨者，並在關鍵時刻加入了反董卓聯盟，試圖推翻暴政。",
      "styleIntro": "袁紹的戰術風格以謀略和權謀著稱：",
      "style": [
        "善於利用家族背景和人脈來鞏固自己的地位。",
        "在戰場上，他常常採取穩健的策略，避免不必要的損失。",
        "他擅長於政治鬥爭，能夠在複雜的局勢中保持優勢。"
      ],
      "styleOutro": "然而，袁紹的優柔寡斷和過於依賴家族背景的缺點，最終成為他失敗的原因。",
      "relationships": [
        {
          "target": "曹操",
          "description": "袁紹與曹操曾是盟友，共同對抗董卓，但隨著權力的增長，兩人最終成為敵人。"
        }
      ],
      "themeSummary": "袁紹的故事是一個關於權力、家族和政治鬥爭的經典案例，展示了在動盪時代中，如何利用背景和策略來爭奪天下。"
    },
    "li-ru": {
      "nameZh": "李儒",
      "titleZh": "謀士",
      "identity": "李儒是三國時期著名的謀士，以其深謀遠慮和冷酷無情而聞名。作為董卓的親信，他在政治和軍事策略上發揮了重要作用。",
      "alignment": "中立邪惡",
      "background": "李儒出身於一個書香門第，自幼便展現出過人的智慧和謀略。他在年輕時期便被董卓賞識，成為其重要的謀士，協助董卓在朝廷中鞏固權力。",
      "joining": "李儒在董卓掌權後，迅速加入其陣營，成為其最信任的謀士之一。他的加入使得董卓的勢力如虎添翼，並在多次戰役中提供了關鍵的策略支持。",
      "styleIntro": "李儒的策略風格以陰險和精密著稱：",
      "style": [
        "擅長設計複雜的計謀，常常能夠預見敵人的下一步行動。",
        "善於利用心理戰術，通過操控對手的情緒來達成目的。",
        "在戰場上，他偏好使用詭計和奇襲來打擊敵人。"
      ],
      "styleOutro": "李儒的策略風格使他成為一個難以捉摸的對手，常常讓敵人防不勝防。",
      "relationships": [
        {
          "target": "董卓",
          "description": "李儒是董卓的得力謀士，兩人關係密切，李儒的計謀多次幫助董卓鞏固其在朝廷的地位。"
        },
        {
          "target": "呂布",
          "description": "李儒對呂布的勇猛有所忌憚，常常在策略上設計以牽制呂布的行動。"
        }
      ],
      "themeSummary": "李儒的故事圍繞著權謀與背叛，展現了在亂世中如何運用智慧和策略來影響歷史進程。"
    }
  },
  "world": {
    "id": "sanguo-excerpt",
    "name": "三国志",
    "movementMode": "atlas",
    "renderMode": "flat",
    "places": [
      {
        "id": "luoyang",
        "realName": "洛阳",
        "archetypes": [
          "capital-hub"
        ],
        "data": {
          "population": 650000,
          "gdp": 50,
          "fame": 90
        },
        "geo": {
          "lat": 34.6197,
          "lng": 112.454
        },
        "connectors": {
          "sw": "jiademen"
        },
        "pos": {
          "x": 43.95139542306998,
          "y": 41.745307452649264
        }
      },
      {
        "id": "jizhou",
        "realName": "冀州",
        "archetypes": [
          "frontier"
        ],
        "data": {
          "population": 3000000,
          "gdp": 80,
          "fame": 70
        },
        "geo": {
          "lat": 37,
          "lng": 115
        },
        "connectors": {
          "nw": "zhongshan"
        },
        "pos": {
          "x": 64.7422906871714,
          "y": 29.00684668071955
        }
      },
      {
        "id": "youzhou",
        "realName": "幽州",
        "archetypes": [
          "frontier"
        ],
        "data": {
          "population": 2500000,
          "gdp": 60,
          "fame": 65
        },
        "geo": {
          "lat": 40,
          "lng": 116
        },
        "connectors": {
          "se": "qingzhou"
        },
        "pos": {
          "x": 62.9810218296363,
          "y": 12
        }
      },
      {
        "id": "zhuoxian",
        "realName": "涿縣",
        "archetypes": [
          "residential"
        ],
        "data": {
          "population": 150000,
          "gdp": 10,
          "fame": 40
        },
        "geo": {
          "lat": 39.485,
          "lng": 115.974
        },
        "connectors": {
          "n": "youzhou"
        },
        "pos": {
          "x": 70.40201602480111,
          "y": 14.988117326229622
        }
      },
      {
        "id": "hulaoguan",
        "realName": "虎牢关",
        "archetypes": [
          "landmark"
        ],
        "data": {
          "population": 0,
          "gdp": 0,
          "fame": 85
        },
        "geo": {
          "lat": 34.72,
          "lng": 113.65
        },
        "connectors": {
          "nw": "sishuiguan"
        },
        "pos": {
          "x": 65.37020784768185,
          "y": 47.30700065397624
        }
      },
      {
        "id": "chenliu",
        "realName": "陈留",
        "archetypes": [
          "market"
        ],
        "data": {
          "population": 500000,
          "gdp": 30,
          "fame": 60
        },
        "geo": {
          "lat": 34.8,
          "lng": 114
        },
        "connectors": {
          "sw": "nanyang",
          "sw2": "yingchuan"
        },
        "pos": {
          "x": 67.12295424481329,
          "y": 39.275439436338374
        }
      },
      {
        "id": "yingchuan",
        "realName": "潁川",
        "archetypes": [
          "residential"
        ],
        "data": {
          "population": 400000,
          "gdp": 25,
          "fame": 55
        },
        "geo": {
          "lat": 34,
          "lng": 113
        },
        "connectors": {
          "ne": "hulaoguan"
        },
        "pos": {
          "x": 57.27528698214765,
          "y": 49.50029459761153
        }
      },
      {
        "id": "qingzhou",
        "realName": "青州",
        "archetypes": [
          "industrial"
        ],
        "data": {
          "population": 3500000,
          "gdp": 90,
          "fame": 75
        },
        "geo": {
          "lat": 36.5,
          "lng": 118.5
        },
        "connectors": {
          "sw": "jianning"
        },
        "pos": {
          "x": 72.51851851851859,
          "y": 31.703703703703688
        }
      },
      {
        "id": "sishuiguan",
        "realName": "汜水关",
        "archetypes": [
          "landmark"
        ],
        "data": {
          "population": 0,
          "gdp": 0,
          "fame": 80
        },
        "geo": {
          "lat": 34.8,
          "lng": 113.5
        },
        "connectors": {
          "e": "chenliu",
          "w": "jiuchong"
        },
        "pos": {
          "x": 58.41863599098211,
          "y": 33.906988646336075
        }
      },
      {
        "id": "zhongshan",
        "realName": "中山",
        "archetypes": [
          "residential"
        ],
        "data": {
          "population": 200000,
          "gdp": 15,
          "fame": 50
        },
        "geo": {
          "lat": 38,
          "lng": 114
        },
        "connectors": {
          "n": "dingzhou"
        },
        "pos": {
          "x": 56.69122493261428,
          "y": 25.83639450600389
        }
      },
      {
        "id": "jiuchong",
        "realName": "九重",
        "archetypes": [
          "landmark"
        ],
        "data": {
          "population": 0,
          "gdp": 0,
          "fame": 95
        },
        "geo": {
          "lat": 34.7,
          "lng": 112.5
        },
        "connectors": {
          "w": "beimangshan"
        },
        "pos": {
          "x": 50.655599894566045,
          "y": 35.8396734539795
        }
      },
      {
        "id": "beimangshan",
        "realName": "北邙山",
        "archetypes": [
          "wilderness"
        ],
        "data": {
          "population": 0,
          "gdp": 0,
          "fame": 70
        },
        "geo": {
          "lat": 34.7,
          "lng": 112.4
        },
        "connectors": {
          "se": "luoyang"
        },
        "pos": {
          "x": 59.54105739515649,
          "y": 41.82785792889575
        }
      },
      {
        "id": "nanyang",
        "realName": "南陽",
        "archetypes": [
          "residential"
        ],
        "data": {
          "population": 800000,
          "gdp": 40,
          "fame": 65
        },
        "geo": {
          "lat": 33,
          "lng": 112.5
        },
        "connectors": {
          "se": "wancheng"
        },
        "pos": {
          "x": 50.73649629819217,
          "y": 54.902898160113914
        }
      },
      {
        "id": "jiademen",
        "realName": "嘉德門",
        "archetypes": [
          "landmark"
        ],
        "data": {
          "population": 0,
          "gdp": 0,
          "fame": 85
        },
        "geo": {
          "lat": 34.6,
          "lng": 112.4
        },
        "connectors": {
          "se": "yingchuan"
        },
        "pos": {
          "x": 51.690295554660516,
          "y": 43.77247906681132
        }
      },
      {
        "id": "anxixian",
        "realName": "安喜縣",
        "archetypes": [
          "residential"
        ],
        "data": {
          "population": 100000,
          "gdp": 8,
          "fame": 45
        },
        "geo": {
          "lat": 38.5,
          "lng": 115
        },
        "connectors": {
          "ne": "zhuoxian"
        },
        "pos": {
          "x": 70.00097066188069,
          "y": 22.978058666242347
        }
      },
      {
        "id": "dingzhou",
        "realName": "定州",
        "archetypes": [
          "residential"
        ],
        "data": {
          "population": 300000,
          "gdp": 20,
          "fame": 50
        },
        "geo": {
          "lat": 38.5,
          "lng": 114
        },
        "connectors": {
          "e": "quyang"
        },
        "pos": {
          "x": 54.34000963938084,
          "y": 17.419804338573876
        }
      },
      {
        "id": "wancheng",
        "realName": "宛城",
        "archetypes": [
          "residential"
        ],
        "data": {
          "population": 600000,
          "gdp": 35,
          "fame": 60
        },
        "geo": {
          "lat": 32.98,
          "lng": 112.53
        },
        "connectors": {
          "ne": "jizhou"
        },
        "pos": {
          "x": 59.08767940917528,
          "y": 57.29229265269514
        }
      },
      {
        "id": "jianning",
        "realName": "建寧",
        "archetypes": [
          "residential"
        ],
        "data": {
          "population": 400000,
          "gdp": 25,
          "fame": 55
        },
        "geo": {
          "lat": 26.5,
          "lng": 102.5
        },
        "connectors": {
          "ne": "jiuchong"
        },
        "pos": {
          "x": 27.481481481481417,
          "y": 88
        }
      },
      {
        "id": "quyang",
        "realName": "曲陽",
        "archetypes": [
          "residential"
        ],
        "data": {
          "population": 150000,
          "gdp": 10,
          "fame": 45
        },
        "geo": {
          "lat": 38.6,
          "lng": 114.7
        },
        "connectors": {
          "se": "anxixian"
        },
        "pos": {
          "x": 62.1116719988849,
          "y": 19.952624150037117
        }
      }
    ],
    "hubs": [
      "jiuchong",
      "nanyang",
      "wancheng",
      "jizhou",
      "zhongshan",
      "dingzhou",
      "beimangshan",
      "quyang",
      "anxixian",
      "luoyang"
    ],
    "winPaths": [
      "dominion",
      "wealth",
      "survival"
    ],
    "victory": {
      "maxTurns": 50,
      "params": {
        "groupsToWin": 5
      }
    },
    "size": {
      "maxPlaces": 19,
      "maxSpaces": 57
    }
  }
}
;